import { render, staticRenderFns } from "./DocumentTypeConfiguration.vue?vue&type=template&id=431b2c5a&"
import script from "./DocumentTypeConfiguration.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports